import React, { Component } from 'react';
import './styles/ModalDrugWebsite.css';

class ModalCombinationSet extends Component{

    componentDidMount(){
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) =>{
        let modal = document.getElementById('modalWindowCombSet');

        if(this.props.showModalWindow && e.target.id !== modal.id && !modal.contains(e.target)){
            this.props.closeModal();
        }
    }

    render(){

        const backdropStyle = {
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            padding: 50
        };

        const modalStyle = {
            backgroundColor: '#fff',
            borderRadius: 5,
            maxWidth: 400,
            minHeight: 150,
            margin: '0 auto',
            marginTop: '125px',
            padding: 30
        };

        var styles = {

            combSetTitle: {
                fontSize: 18,
                fontWeight: 'bold'
            },

            enterAmtTitle: {
                fontSize: 16,
                marginTop:10
            },

            combInput: {
                border: 'none',
                fontSize: 16,
                marginTop: 15
            },

            modalLinks: {
                marginLeft: 85,
                marginTop: 5
            },

            closeOkayLinks: {
                marginLeft: 20
            }
        };

        if(!this.props.showModalWindow){
            return null;
        }

        return (
            <div style={backdropStyle}>
                <div id="modalWindowCombSet" style={modalStyle}>
                    <div>
                        <div style={styles.combSetTitle}>
                            <span>Combination Set</span>
                        </div>
                        <div style={styles.enterAmtTitle}>
                            <span>Enter Amount</span>
                        </div>
                        <div>
                            <input id="combSetInput" type="text" style={styles.combInput} autoFocus/>
                        </div>
                    </div>
                    <div>
                        <div style={styles.modalLinks}>
                            <a style={styles.closeOkayLinks} href="" onClick={(e) => this.props.closeModal(e)}>Cancel</a>
                            <a style={styles.closeOkayLinks} href="" onClick={(e) => this.props.setCombinationSetValue(e)}>Okay</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalCombinationSet;


// WEBPACK FOOTER //
// ./src/ModalCombinationSet.js